// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/**
 * 上传文件到TOS对象存储
 * @param params 上传参数
 * @returns 文件上传结果
 */
export async function uploadFile(params: OA.FileUploadParams) {
  return request<OA.ApiResponse<OA.FileUploadResult>>('/api/v1/file-upload/upload', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  });
}

